import React from 'react';
import { FaBriefcase, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

const JobOpenings = () => {

  const [isSubmitted, setIsSubmitted] = useState(false);


  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSubmitted(true); // disable the button immediately

    emailjs
      .sendForm('service_yalh5wy', 'template_nchb1xi', form.current, {
        publicKey: '_IokqDxhynHK8phwD',
      })
      .then(
        () => {
          alert('Submitted successfully!');
          form.current.reset();         // Optional: clear form fields
          setIsSubmitted(true);         // Keep button disabled
        },
        (error) => {
          console.log('FAILED...', error.text);
          setIsSubmitted(false);        // Re-enable button on failure
        }
      );
  };

  const jobData = [
    {
      title: 'Bussiness Development Executive:',
      type: 'FULL-Time',
      location: '',
      experience: '1 Years (Experience)',
      description: [
        <strong style={{ color: 'black' }}>Job Description :</strong>,
        'We are looking for a competitive and trustworthy Business Development executive to help build up and grow our company.',
        <strong style={{ color: 'black' }}>Responsibilities:</strong>,
        '• Acquiring New IT Positions from the clients.',
        '• Maintains an ongoing relationship with both prospective and existing clients.',
        '• Contacting potential clients via e-mail or phone to establish rapport and set up meetings.',
        '• Excellent organizational skills, with emphasis on priorities and goal setting.',
        '• Strong proficiency in Microsoft Word, Excel, PowerPoint and statistical analysis software',
        '• Superior presentation and communication skills, both written and verbal.',
        '• Technical skills required to understand and propose products or solutions by focusing on client requirements.',
        '• Should have knowledge in lead generation, client interaction, cold calling and gathering requirements.',
        '• Researching organizations and individuals online to identify new leads and potential new markets.',
        '• Contacting potential clients via e-mail or phone to establish rapport and set up meetings.',
        <strong style={{ color: 'black' }}>Requirements:</strong>,
        '• Proven experience as a BD Executive or relevant role',
        '• Proficiency in English',
        '• Excellent knowledge of MS Office',
        '• Thorough understanding of marketing and negotiating techniques',
        '• Fast learner and passion for sales',
        '• Self-motivated with a results-driven approach',
        '• Goal-oriented',
        'Salary: Based on experience and knowledge'
      ]
    },
    {
      title: 'Bussiness Development Manager"',
      type: 'Full-Time',
      location: '',
      experience: '5 Years (Experience)',
      description: [
        <strong style={{ color: 'black' }}>Job Description:</strong>,
        'Business Development Manager',
        '',
        'Job Description for Business Development Manager:',
        'We are currently looking for experienced BDM with good experience in the both domestic and international market. We balance a fixed salary with very aggressive incentive plans for BDM position.',
        '',
        <strong style={{ color: 'black' }}>Technical Skills Required:</strong>,
        '• Must have good experience in Business Development for IT solutions.',
        '• Should have exposure in both Domestic and International market.',
        '• Experience in Microsoft and open-source technologies.',
        '• Experience with Project Bidding sites',
        '• Generation of new clients, Maintain existing clients.',
        '• Should have excellent sales, negotiation, commercial and presentational skills and the ability to communicate clearly and concisely at all levels.',
        '',
        <strong style={{ color: 'black' }}>Other Requirements:</strong>,
        '• Ability to work in a team and handle pressure and demands.',
        '• Sound knowledge of IT concepts and latest trends.',
        '• Ability to work independently and multitask in a fast-paced environment.',
        '• Strong communication and interpersonal skills.',
        '• Goal-oriented.',
        '',
        'Salary: Depends on Experience and knowledge.'
      ]
    },
    {
      title: 'PHP Developer:',
      type: 'Full-Time',
      location: 'G 35, Basement, Near Kalindi Kunj, New Delhi-110025',
      experience: '3 Year (Experience)',
      description: [
        <strong style={{ color: 'black' }}>Job Description:</strong>,
        '',
        'The Food Service Specialist ensures outstanding customer service is provided to food customers and that all food offerings meet the required stock levels and presentation standards. Beginning your career as a Food Steward will give you a strong foundation in Speedway’s food segment that can make you a vital member of the front line team!',
        '',
        '• Executing the Food Service program, including preparing and presenting our wonderful food offerings to hungry customers on the go!',
        '• Greeting customers in a friendly manner and suggestive selling and sampling items to help increase sales.',
        '• Keeping our Store food area looking terrific and ready for our valued customers by managing product inventory, stocking, cleaning, etc.',
        '',
        'We’re looking for associates who enjoy interacting with people and working in a fast-paced environment!'
      ]
    }
  ];

  return (
    <div id='jobOpen' className="container my-5 text-start" style={{ scrollMarginTop: '95px' }}>
      {jobData.map((job, index) => (
        <div key={index} className="border rounded p-4 mb-4 bg-white shadow-sm">
          <h5 className="text-primary fw-bold mb-3">{job.title} :</h5>

          <div className="d-flex flex-wrap text-secondary mb-3 gap-3">
            <div className="d-flex align-items-center me-4">
              <FaBriefcase className="me-2 text-info" />
              {job.type}
            </div>
            <div className="d-flex align-items-center me-4">
              <FaMapMarkerAlt className="me-2 text-danger" />
              {job.location}
            </div>
            <div className="d-flex align-items-center">
              <FaClock className="me-2 text-warning" />
              {job.experience}
            </div>
          </div>


          {job.description.map((line, i) => (
            <p key={i} className="text-secondary" style={{ textAlign: 'justify' }}>
              {line}
            </p>
          ))}

          <button className="btn btn-info text-white mt-3" data-bs-toggle="modal" data-bs-target="#getInTouchModal">
            Apply for this job
          </button>
        </div>
      ))}

      <p className='py-4 text-secondary'>We are a fast growing startup with the motive to provide technology to all educational organizations so that our coming generation could receive quality education. With the team of experienced professionals and the young creative minds, we encourage our employees to grow and be innovative to survive this competitive market. Joining your hands with us will grow you in all aspects because we are not just an organisation, we are a family.</p>


      {/* button function */}
      <div
        className="modal fade"
        id="getInTouchModal"
        tabIndex="-1"
        aria-labelledby="getInTouchModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content border-0 shadow-lg rounded-4" style={{ overflow: "hidden" }}>
            <div className="modal-header bg-white border-0 pt-4 px-4 pb-2">
              <h5
                className="modal-title fw-bold"
                id="getInTouchModalLabel"
                style={{ color: "rgb(4,180,228)", fontSize: "2rem" }}
              >
                Join Our Team
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <hr style={{
              borderTop: "2px solid rgb(4,180,228)",
              opacity: "1",
              margin: "0 1.5rem"
            }} />

            <div className="modal-body bg-white px-4 pb-4 pt-3">
              <form ref={form} onSubmit={sendEmail}>
                {/* Full Name and Email */}
                <div className="row g-3 mb-3">
                  <div className="col-md-6 text-start">
                    <label className="form-label text-dark fw-semibold" style={{ fontSize: "1.05rem" }}>
                      Name
                    </label>
                    <input
                      type="text"
                      className="form-control border border-2 rounded-3 py-2 px-3"
                      placeholder="Your Name*"
                      style={{ fontSize: "1.05rem" }}
                      required
                      name="name"
                    />
                  </div>
                  <div className="col-md-6 text-start">
                    <label className="form-label text-dark fw-semibold" style={{ fontSize: "1.05rem" }}>
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-control border border-2 rounded-3 py-2 px-3"
                      placeholder="Email*"
                      style={{ fontSize: "1.05rem" }}
                      required
                      name="email"
                    />
                  </div>
                </div>

                {/* Mobile No. */}
                <div className="mb-3 text-start">
                  <label className="form-label text-dark fw-semibold" style={{ fontSize: "1.05rem" }}>
                    Mobile Number
                  </label>
                  <input
                    type="tel"
                    className="form-control border border-2 rounded-3 py-2 px-3"
                    placeholder="Mobile Number*"
                    style={{ fontSize: "1.05rem" }}
                    required
                    name="phone"
                  />
                </div>

                {/* Why Join Warals */}
                <div className="mb-3 text-start">
                  <label className="form-label text-dark fw-semibold" style={{ fontSize: "1.05rem" }}>
                    Why Join Warals?
                  </label>
                  <textarea
                    className="form-control border border-2 rounded-3 py-2 px-3"
                    placeholder="Share your motivation..."
                    style={{ fontSize: "1.05rem", minHeight: "90px" }}
                    name="message"
                  ></textarea>
                </div>

                {/* Resume Upload */}
                <div className="mb-4 text-start">
                  <label className="form-label text-dark fw-semibold" style={{ fontSize: "1.05rem" }}>
                    Upload Resume
                  </label>
                  <input
                    type="file"
                    className="form-control border border-2 rounded-3 py-2 px-3"
                    style={{ fontSize: "1.05rem" }}
                    required
                    name="resume"
                    accept=".pdf,.doc,.docx"
                  />
                  <div className="form-text" style={{ fontSize: "0.9rem" }}>PDF, DOC, or DOCX files only</div>
                </div>

                {/* Buttons */}
                <div className="d-flex justify-content-between mt-4">
                  <button
                    type="button"
                    className="btn btn-outline-secondary px-4 py-2 fw-semibold"
                    style={{
                      borderRadius: "10px",
                      fontSize: "1.05rem",
                      width: "48%"
                    }}
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={isSubmitted}
                    className="btn text-white px-5 py-3 fw-semibold"
                    style={{
                      backgroundColor: isSubmitted ? '#ccc' : 'rgb(4,180,228)',
                      borderRadius: '12px',
                      fontSize: '1.1rem',
                      transition: 'all 0.3s ease',
                      width: '100%',
                      maxWidth: '300px',
                      cursor: isSubmitted ? 'not-allowed' : 'pointer'
                    }}
                    onMouseOver={(e) => {
                      if (!isSubmitted) e.target.style.backgroundColor = '#00a8d4';
                    }}
                    onMouseOut={(e) => {
                      if (!isSubmitted) e.target.style.backgroundColor = 'rgb(4,180,228)';
                    }}
                  >
                    {isSubmitted ? "Submitted" : "Submit"}
                  </button>

                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default JobOpenings;
